import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { Spacer } from './Spacer';
import * as S from './Skeletons.styles';

export { CSkeleton, AssessmentCardSkeleton, ButtonSkeleton } from './Skeletons.styles';

export const TableSkeleton = ({ rowHeight = 48 }: { rowHeight?: 32 | 48 }) => (
  <S.ThreeColGrid>
    <S.CSkeleton height={rowHeight} count={3} />
    <S.CSkeleton height={rowHeight} count={3} />
    <S.CSkeleton height={rowHeight} count={3} />
  </S.ThreeColGrid>
);

export const TimelineSkeleton = () => (
  <S.TimelineWrap>
    <S.CSkeleton height={20} count={10} />
  </S.TimelineWrap>
);

export const ModifierModalSkeleton = () => (
  <>
    <S.CSkeleton height={30} />
    <Spacer $px={20} />
    <S.CSkeleton height={200} />
    <Spacer $px={20} />
    <S.ButtonsRowEnd>
      <S.ButtonSkeleton />
      <S.ButtonSkeleton />
    </S.ButtonsRowEnd>
    <Spacer $px={20} />
    <TableSkeleton />
  </>
);

export const UserProfileModalSkeleton = () => (
  <>
    <S.CSkeleton height={30} width={400} />
    <Spacer $px={20} />
    <S.CSkeleton height={70} width={70} circle />
    <Spacer $px={20} />
    <S.TwoColGrid>
      <S.CSkeleton height={48} count={2} />
      <Spacer $px={1} />
      <S.CSkeleton height={48} count={2} />
    </S.TwoColGrid>
    <Spacer $px={20} />
    <S.ButtonSkeleton />
    <Spacer $px={20} />
  </>
);

export const ScenarioModalSkeleton = () => (
  <>
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.TwoColGrid>
      <S.CSkeleton height={48} />
      <Spacer $px={1} />
      <S.CSkeleton height={48} />
    </S.TwoColGrid>
    <Spacer $px={20} />
    <S.CSkeleton height={150} />
    <Spacer $px={20} />
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.CSkeleton height={48} />
  </>
);

export const ActionsModalSkeleton = () => (
  <>
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.TwoColGrid>
      <S.CSkeleton height={48} />
      <Spacer $px={1} />
      <S.CSkeleton height={48} />
    </S.TwoColGrid>
  </>
);

export const PageChartSkeleton = () => (
  <>
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.CSkeleton height={250} />
    <Spacer $px={20} />
    <TableSkeleton />
  </>
);
export const PageFrameworkLibSkeleton = () => (
  <>
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <S.CSkeleton height={48} />
    <Spacer $px={20} />
    <TableSkeleton />
  </>
);

export const PageControlSkeleton: React.FC<{ noTable?: boolean }> = ({ noTable }) => {
  return (
    <>
      <S.CSkeleton height={48} />
      <Spacer $px={20} />
      <S.CSkeleton height={20} />
      <Spacer $px={10} />
      <S.CSkeleton height={20} />
      <Spacer $px={10} />
      <S.CSkeleton height={20} />
      {!noTable && (
        <>
          <Spacer $px={20} />
          <TableSkeleton />
        </>
      )}
    </>
  );
};

export const CommentSkeleton = () => (
  <S.CommentColumn>
    <S.CSkeleton height={60} />
    <S.CSkeleton height={60} />
    <S.CSkeleton height={60} />
  </S.CommentColumn>
);

export const PageOrgSkeleton = () => (
  <>
    <S.OrgHeaderRow>
      <S.CSkeleton height={45} width={45} circle />
      <S.CSkeleton height={30} width={300} />
    </S.OrgHeaderRow>
    <Spacer $px={20} />
    <S.CSkeleton height={30} width={400} />
    <Spacer $px={20} />
    <S.TwoColGrid>
      <S.CSkeleton height={48} count={3} />
      <Spacer $px={1} />
      <S.CSkeleton height={48} count={3} />
    </S.TwoColGrid>
    <Spacer $px={20} />
    <S.ButtonSkeleton />
    <Spacer $px={20} />
  </>
);
